<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const staffSchema = defineSchema({
	name: $.text('Name'),
	position: $.text('Position'),
	image: $.upload('Photo', { height: '100px' }),
	bio: $.richtext('Biography', { basic: true }),
})
const defaults = {
	title: 'Staff',
	subtitle: '',
	staff: [
		{
			name: 'Rabbi David Steinberg',
			position: 'Co-Founder and Director',
			image: '/staff/David-Steinberg.jpg',
			bio: 'Rabbi David Steinberg co-founded TheTorah.com in 2012 and has served as its Director since then. He studied at Manchester Yeshiva under Rav Yehuda Zev Segal zt"l, at Gateshead Yeshiva, and at Mir Yeshiva in Jerusalem. He also trained with the Ner Le\'Elef Rabbinical Outreach program. Before founding the site, he worked in outreach for the Mesorah Center and as Programs Director at Aish HaTorah NY.',
		},
		{
			name: 'Prof. Marc Zvi Brettler',
			position: 'Supervising Editor and Co-Founder',
			image: '/staff/Marc-Zvi-Brettler.jpg',
			bio: 'Prof. Marc Zvi Brettler is Bernice & Morton Lerner Professor of Judaic Studies at Duke University and Dora Golding Professor of Biblical Studies (Emeritus) at Brandeis University. He studied under Nahum Sarna at Brandeis and at the Hebrew University in Jerusalem. His books include <em>How to Read the Jewish Bible</em>, <em>The Jewish Study Bible</em> (co-edited with Adele Berlin), and <em>The Bible and the Believer</em> (with Peter Enns and Daniel Harrington). He is a member of the American Academy of Jewish Research.',
		},
		{
			name: 'Dr. Rabbi Zev Farber',
			position: 'Senior Editor and Fellow',
			image: '/staff/Zev-Farber.jpg',
			bio: 'Dr. Zev Farber holds a Ph.D. in Jewish Religious Cultures (Hebrew Bible focus) from Emory University, an M.A. in Jewish History (biblical period) from the Hebrew University, and a B.A. in psychology from Touro College. He received rabbinic ordination (<em>yoreh yoreh</em>) and advanced ordination (<em>yadin yadin</em>) from Yeshivat Chovevei Torah. He is the editor of <em>Halakhic Realities: Collected Essays on Brain Death</em> and author of <em>Images of Joshua in the Bible and Their Reception</em>.',
		},
		{
			name: 'Dr. Tina M. Sherman',
			position: 'Editor, TheTorah.com',
			image: '/staff/Tina-Sherman.jpg',
			bio: 'Dr. Tina M. Sherman holds a Ph.D. in Near Eastern and Judaic Studies from Brandeis University. She lectures in Bible at the University of Minnesota. Her research examines how prophetic authors used plant metaphors to construct national identities for Israel and Judah. She is the author of the <em>Biblical Metaphor Annotated Bibliography</em> and co-author of "Law and Legal Literature" in <em>The Wiley Blackwell Companion to Ancient Israel</em>.',
		},
		{
			name: 'Dr. Hilary Lipka',
			position: 'Editor, TheTorah.com',
			image: '/staff/Hilary-Lipka.jpg',
			bio: 'Dr. Hilary Lipka teaches in the Religious Studies Program at the University of New Mexico, main campus. She earned her M.A. and Ph.D. from the Department of Near Eastern and Judaic Studies at Brandeis University. She is the author of <em>Sexual Transgression in the Hebrew Bible</em> and co-editor of the forthcoming <em>Sexuality and Law in the Torah</em>.',
		},
		{
			name: 'Emily Branton',
			position: 'Editor, TheTorah.com',
			image: '/staff/Emily-Branton.jpg',
			bio: 'Emily Branton is a Ph.D. candidate in the Department of Religious Studies at the University of North Carolina at Chapel Hill. She earned her B.A. in Religious Studies at Smith College and an M.A. from the University of Chicago Divinity School. Her dissertation, <em>Words that Stand: Efficacious Speech in Ancient Israel</em>, explores how ancient scribes understood and described acts of speech using speech-act theory, metaphor, and cognitive linguistics.',
		},
		{
			name: 'Dr. Avi Dentelski',
			position: 'Fellow',
			image: '/staff/Avi-Dentelski.jpg',
			bio: 'Dr. Avi Dentelski holds a Ph.D. and M.A. in Biblical Studies from Ariel University, both awarded with highest honors. He has published academic articles and is the author of the Hebrew-language academic chumash <em>התורה ומקורותיה</em>. He also runs a blog titled <em>Eretz Ha\'Ivrim</em>, which discusses the Bible and contemporary Judaism. He is married and the father of four, and works in information systems project management.',
		},
		{
			name: 'David Bar-Cohn',
			position: 'Manager of Operations',
			image: '/staff/David-Bar-Cohn.jpg',
			bio: 'David Bar-Cohn holds an M.A. in Bible (magna cum laude) from Bar-Ilan University, where he wrote his thesis on priestly purification. He is the author of <em>Ohr HaShachar: Torah, Kabbalah and Consciousness in the Daily Morning Blessings</em>. He also holds an M.A. in Clinical Psychology and received semikha in <em>Yoreh De\'ah</em>. He grew up in Los Angeles and lives in Beit Shemesh, Israel.',
		},
		{
			name: 'Dr. Flora Anthony',
			position: 'Director of Grants',
			image: '/staff/Flora-Anthony.jpg',
			bio: 'Dr. Flora Brooke Anthony is an Egyptologist and Subject Matter Expert featured on the History Channel and the Discovery Channel. She earned her Ph.D. in Art History from Emory University and holds a master\'s from the Institute of Egyptian Art and Archaeology at the University of Memphis. Flora is the author of <em>Foreigners in Ancient Egypt: Theban Tomb Paintings from the Early Eighteenth Dynasty (2016).</em>.',
		},
		{
			name: 'Dr. Gili Kugler',
			position: 'Academic Editor, TheTorah.co.il',
			image: '/staff/Gili-Kugler.jpg',
			bio: 'Dr. Gili Kugler is a senior lecturer in Bible at the University of Haifa. She joined the university in 2021 after six years teaching Bible and Classical Hebrew at the University of Sydney. Her work focuses on biblical traditions, election theology, Psalms, and biblical myth in psychological perspective. Her book is titled <em>When God Wanted to Destroy the Chosen People: Biblical Traditions and Theology on the Move</em>.',
		},
		{
			name: 'Dr. Shira Golani',
			position: 'Academic Editor, TheTorah.co.il',
			image: '/staff/Shira-Golani.jpg',
			bio: 'Dr. Shira Golani teaches in the Bible Department at Gordon Academic College (Haifa) and is a guest researcher in the Hebrew University Bible Project (Jerusalem). She earned her Ph.D. from the Hebrew University. Her publications include "Three Oppressors and Four Saviors" and "Swords that are Ploughshares: Another Case of (Bilingual) Wordplay in Biblical Prophecy?".',
		},
		{
			name: 'Hila Hershkowitz',
			position: 'Associate Editor, TheTorah.co.il',
			image: '/staff/Hila-Hershkowitz.jpg',
			bio: 'Hila Hershkowitz holds an M.A. in Bible from Herzog College. Her article on the Sinai experience was published in <em>And on Shavuot – Essays on the Festival of Shavuot</em> (Herzog College – Tevunot, 2022). She writes for <em>Vision</em> magazine and <em>Times of Israel</em>, and is active in the Lavi educational movement. She also lectures on Israeli advocacy and indigenous rights.',
		},
		{
			name: 'Oded Levine',
			position: 'Associate Editor, TheTorah.co.il',
			image: '/staff/Oded-Levine.jpg',
			bio: 'Oded Levine holds a B.A. in Oral Torah Education and Literature from Herzog College and a certificate in language editing from David Yellin College. He studied in the Hesder program at Yeshivat Otniel. He works as an editor and translator from English and specializes in Bible, Talmud, halakha, and Jewish thought. His article on incitement in Jewish law won the 2021 Tsahar–Palm Beach award.',
		},
	] as Array<{ name: string, position: string, image: string, bio?: string }>,
}
const schema = defineSchema({
	title: $.text('Title'),
	subtitle: $.text('Subtitle'),
	staff: $.array('Staff Members', staffSchema, { collapsible: true }),
})
export const Staff = defineBlock({ name: 'Staff', label: 'Staff / Team', icon: 'group', order: 5, schema, defaults })
</script>
<script setup lang="ts">

import { Dialog, $ } from '@bagelink/vue'
import { ref } from 'vue'





const myData = defineProps<{
	title?: string
	subtitle?: string
	staff?: Array<{
		name: string
		position: string
		image: string
		bio?: string
		contactName?: string
		contactTitle?: string
		contactEmail?: string
	}>
}>()

const modalOpen = ref(false)
const selectedMember = ref<{ name: string, position: string, image: string, bio?: string } | null>(null)

function openBio(member: any) {
	selectedMember.value = member
	modalOpen.value = true
}
</script>

<template>
	<div id="staff" class="m_pt-2">
		<Dialog v-if="selectedMember" v-model:open="modalOpen" width="l">
			<div class="p-1 m_p-05">
				<div class="flex gap-1 align-items-center pb-2 m_pb-1">
					<img :src="selectedMember.image" :alt="selectedMember.name" class="h70px m_h50px aspect-ratio-1 round">
					<div>
						<p class="pt-05">
							{{ selectedMember.name }}
						</p>
						<p class="balance txt12">
							{{ selectedMember.position }}
						</p>
					</div>
				</div>
				<div class="light paddingP" v-html="selectedMember.bio" />
			</div>
		</Dialog>
		<div class="txt-center bg-gray-light py-6 m_pb-2 m_pt-3">
			<div class="w1050px">
				<div class=" pb-4 m_pb-2">
					<div class="flex gap-1 justify-content-center">
						<div class="line w150px m_w60px" />
						<h3 class="m-0 txt40 regular m_txt30 line-height-12 white-space ">
							{{ myData.title }}
						</h3>
						<div class="line w150px m_w60px" />
					</div>
					<p class="m-0 txt20 regular m_txt16 line-height-12 white-space pt-1">
						{{ myData.subtitle }}
					</p>
				</div>
				<div class="flex flex-wrap gap-2 m_gap-1 justify-content-center align-items-start">
					<div
						v-for="(member, index) in myData.staff"
						:key="index"
						class="stuffBox flex-grow-0 flex-shrink-0 transition-400 pointer"
						@click="openBio(member)"
					>
						<img :src="member.image" :alt="member.name" class="h150px m_h120px aspect-ratio-1 round">
						<p class="pt-05 m_line-height-14 m_py-05">
							{{ member.name }}
						</p>
						<p class="balance m_line-height-14 m_pb-1 txt12">
							{{ member.position }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
.stuffBox {
	width: 182px;
	filter: grayscale(100%);
}
.stuffBox:hover {
	filter: grayscale(0%);
}
@media screen and (max-width: 910px) {
	.stuffBox {
	width: 170px;
	}
}
</style>
